import { createSlice } from '@reduxjs/toolkit';

const websocketSlice = createSlice({
  name: 'websocket',
  initialState: {
    isConnected: false,
    isReconnecting: false,
  },
  reducers: {
    connected: (state) => {
      //console.log('WebSocket state: connected');
      state.isConnected = true;
      state.isReconnecting = false;
    },
    disconnected: (state) => {
      //console.log('WebSocket state: disconnected');
      state.isConnected = false;
    },
    reconnecting: (state) => {
      //console.log('WebSocket state: reconnecting');
      state.isReconnecting = true;
    },
  },
});

export const { connected, disconnected, reconnecting } = websocketSlice.actions;
export default websocketSlice.reducer;

